export default __webpack_public_path__ + "static/TeamBack-8d4bb35e4cc3ff8a96ba70f9cfbbeff0.webp";